@if (spec$ | async; as spec) {
  <div class="layout-col full">
    @if (conf$ | async; as conf) {
      <div class="layout-col full">
        <div class="layout-col p-xs gap-xs" elderPlugParentForm>
          <!-- serial number regex input field -->
          @if (spec?.serialNumber?.regex) {
            <mat-form-field class="flex" elderDense>
              <input
                matInput
                name="serial-number-input- + {{ uuid }}"
                pattern="{{ spec.serialNumber.regex }}"
                placeholder="{{ 'batchtracing.serial-number.title' | translate }}"
                [(ngModel)]="conf.serialNumber"
              />
            </mat-form-field>
          }
          <!-- vendors input field -->
          @if (spec?.vendors?.length ?? 0 > 0) {
            <mat-form-field elderDense>
              <elder-select
                appVendorSelect
                valueAsId
                [selectableIds]="spec?.vendors ?? []"
                [value]="conf.vendor"
                (valueUpdated)="onVendorSelectionChange($event)"
                placeholder="{{ 'manufacturer.title' | translate }}"
              >
              </elder-select>
            </mat-form-field>
          }
        </div>
      </div>
    }
  </div>
}
